import { readFromBinaryFile } from "exif-js"
import { parseDate } from "utils/string"

export const extractTypeAndDate = async (file: File) => {
  let mediaType: string
  let originalDate: Date
  if (file.type === 'image/jpeg') {
    mediaType = 'image'
    originalDate = await extractOriginalDateFromExif(file)
  } else if (file.type === 'video/mp4' || file.type === 'video/quicktime') {
    mediaType = 'video'
    originalDate = new Date()
  } else {
    throw new Error('media type is not expected.')
  }

  return {
    mediaType,
    originalDate
  }
}

const extractOriginalDateFromExif = async (file: File): Promise<Date> => {
  return new Promise((resolve, reject) => {
    const fr = new FileReader()
    fr.onload = e => {
      const bytes = e.target?.result
      const exif = readFromBinaryFile(bytes)
      const dateString = exif['DateTimeOriginal']
      const date = dateString ? parseDate(dateString) : new Date()
      resolve(date)
    }
    fr.readAsArrayBuffer(file)
  })
}